import { connect } from 'react-redux';
import { isMobile } from '@zola-helpers/client';

import { getGuestCollection } from 'selectors/guestCollection';
import { mapGuestCollectionToFormValues } from 'components/manage/guestlist/addressCollection/helpers/mapper';
import ConfigureAddressCollectionFormValues from 'components/manage/guestlist/addressCollection/@types/formValues';

import { showModal } from 'actions/ModalActions';
import { ModalActionTypes } from 'actions/types/ModalActionTypes';
import disableModal, {
  DISABLED_MODALS,
} from 'components/manage/guestlist/addressCollection/helpers/disableModal';

import ConfigureAddressCollectionLinkContainer from './ConfigureAddressCollectionLinkContainer';
import type { RootState, AppDispatch } from '../../../../../reducers';

const modalStylesOverride = isMobile()
  ? {
      margin: '-10px',
      height: '100%',
    }
  : { top: '160px' };

export type ConfigureAddressCollectionLinkContainerStateProps = {
  formattedFormValues: ConfigureAddressCollectionFormValues;
};

const mapStateToProps = (state: RootState): ConfigureAddressCollectionLinkContainerStateProps => ({
  formattedFormValues: mapGuestCollectionToFormValues(getGuestCollection(state)),
});

export type ConfigureAddressCollectionLinkContainerDispatchProps = {
  openMagicLinkWelcomeModal: () => void;
};

const mapDispatchToProps = (
  dispatch: AppDispatch
): ConfigureAddressCollectionLinkContainerDispatchProps => ({
  openMagicLinkWelcomeModal: (): ModalActionTypes =>
    dispatch(
      showModal(
        'MAGIC_LINK_WELCOME_MODAL',
        {
          onHideModal: (): void => disableModal(DISABLED_MODALS.MAGIC_LINK_WELCOME),
        },
        { size: 'md', styleOverride: modalStylesOverride }
      )
    ),
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(ConfigureAddressCollectionLinkContainer);



// WEBPACK FOOTER //
// ./src/components/manage/guestlist/addressCollection/ConfigureAddressCollectionLinkContainer/index.ts